<template>
  <div class="my_border_layer">
    <my_radio
      :titleWidth="titleWidth"
      :title="title"
      :option="option"
      :defaultIsShow="defaultIsShow"
      :hiddenIsShow="hiddenIsShow"
      :selfIsShow="selfIsShow"
      :defaultIsDisabled="defaultIsDisabled"
      :hiddenIsDisabled="hiddenIsDisabled"
      :selfIsDisabled="selfIsDisabled"
      :selectValue.sync="radio_value"
    >
      <div slot="pull_down_control">
        <p class="setOne">
          <my_color
            :titleWidth="subTitleWidth"
            :title="colorTitle"
            :color.sync="color_value"
            v-if="color_value !==undefined"
            :type="type"
          ></my_color>
          <my_color
            :titleWidth="secondColorTitleWidth"
            :title="selectColorTitle"
            :color.sync="select_color"
            v-if="select_color !==undefined"
            class="select_color"
            :type="type"
          ></my_color>
        </p>
        <!-- <my_color :titleWidth="titleWidth" :title="colorTitle" :color.sync="color_value" v-if="color_value !==undefined"></my_color> -->
        <my_slider
          v-if="slider_value !==undefined"
          :titleWidth="subTitleWidth"
          :title="sliderTitle"
          :value.sync="slider_value"
          :max='max'
          :type="type"
          class="slider-width"
        ></my_slider>
        <my_line_style
          :titleWidth="subTitleWidth"
          :title="lineStyleTitle"
          :options="$store.state.options.lineType"
          :value.sync="line_style_value"
          v-if="line_style_value !==undefined"
          :type="type"
        ></my_line_style>
        <my_checkbox
          :titleWidth="subTitleWidth"
          :title="checkBoxTitle"
          :checkList.sync="check_box_value"
          v-if="check_box_value !== undefined"
          :option="checkListOption"
          :type="type"
        ></my_checkbox>
      </div>
    </my_radio>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_border_index',
  props: {
    secondColorTitleWidth: {
      type: String,
      default: '86'
    },
    titleWidth: {
      type: String,
      default: '40'
    },
    subTitleWidth: {
      type: String,
      default: '75'
    },
    type: { // 组件的标题
      type: String,
      default: 'two_level'
    },
    title: { // 组件的标题
      type: String,
      default: i18n.t('widgets_basic_button_edit_447')
    },
    colorTitle: { // 组件的标题
      type: String,
      default: i18n.t('view_back_top_edit_99')
    },
    selectColorTitle: {
      type: String,
      default: i18n.t('widgets_basic_button_edit_446')
    },
    lineStyleTitle: {
      type: String,
      default: i18n.t('widgets_basic_h1_edit_576')
    },
    sliderTitle: {
      type: String,
      default: i18n.t('widgets_basic_article_list_edit_375')
    },
    checkBoxTitle: {
      type: String,
      default: i18n.t('components_my_border_index_2295')
    },
    max: {
      type: Number
    },
    radioValue: {
      type: String
    },
    colorValue: {
      type: String
    },
    selectColor: {
      type: String
    },
    sliderValue: {
      type: Number
    },
    lineStyleValue: {
      type: String
    },
    checkBoxValue: {
      type: Array
    },
    option: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultIsShow: {
      type: String,
      default: 'true'
    },
    hiddenIsShow: {
      type: String,
      default: 'true'
    },
    selfIsShow: {
      type: String,
      default: 'true'
    },
    defaultIsDisabled: { // 默认设置是否禁用
      type: String,
      default: 'false'
    },
    hiddenIsDisabled: { // 隐藏设置是否禁用
      type: String,
      default: 'false'
    },
    selfIsDisabled: { // 自定义设置是否禁用
      type: String,
      default: 'false'
    },
    checkListOption: { // 多选框列表数组
      type: Array,
      default: function () {
        return this.$store.state.options.borderPosition
      }
    },
    checkValueList: { // 多选框列表选中的数组
      type: Array,
      default: function () {
        return this.$store.state.options.checkValueList
      }
    },
    borderTopWidth: {
      type: Number
    },
    borderBottomWidth: {
      type: Number
    },
    borderLeftWidth: {
      type: Number
    },
    borderRightWidth: {
      type: Number
    },
  },
  data() {
    return {
      radio_value: this.radioValue,
      color_value: this.colorValue,
      select_color: this.selectColor,
      slider_value: this.sliderValue,
      line_style_value: this.lineStyleValue,
      check_box_value: this.checkBoxValue,
      border_top_width: this.borderTopWidth,
      border_bottom_width: this.borderBottomWidth,
      border_left_width: this.borderLeftWidth,
      border_right_width: this.borderRightWidth,
    }
  },
  mounted() {
  },
  watch: {
    radio_value(val) { // 数据双向绑定
      this.$emit('update:radioValue', val)
    },
    color_value(val) { // 数据双向绑定
      this.$emit('update:colorValue', val)
    },
    select_color(val) { // 数据双向绑定
      this.$emit('update:selectColor', val)
    },
    slider_value(val) { // 数据双向绑定
      this.setBorderWidth(this.check_box_value, val)
      this.$emit('update:sliderValue', val)
    },
    line_style_value(val) { // 数据双向绑定
      this.$emit('update:lineStyleValue', val)
    },
    check_box_value(val) { // 数据双向绑定
      this.setBorderWidth(val, this.slider_value)
      this.$emit('update:checkBoxValue', val)
    },
    'radioValue'(val) { // 数据双向绑定
      this.radio_value = val
    },
    'colorValue'(val) { // 数据双向绑定
      this.color_value = val
    },
    'selectColor'(val) { // 数据双向绑定
      this.select_color = val
    },
    'sliderValue'(val) { // 数据双向绑定
      this.setBorderWidth(this.check_box_value, val)
      this.slider_value = val
    },
    'lineStyleValue'(val) { // 数据双向绑定
      this.line_style_value = val
    },
    'checkBoxValue'(val) { // 数据双向绑定
      this.setBorderWidth(val, this.slider_value)
      this.check_box_value = val
    },
  },
  computed: {},
  methods: {
    setBorderWidth(checkList, width) {
      if (this.check_box_value !== undefined) {
        this.checkValueList.forEach(key => {
          if (checkList.indexOf(key) > -1) {
            this.$emit('update:' + key, width)
          } else {
            this.$emit('update:' + key, 0)
          }
        })
      }
    }
  }
}
</script>

<style scoped type="text/css" lang="scss">
.setOne {
  display: flex;
  justify-content: flex-start;
}

.select_color {
  /deep/ .set_two_level .title {
    width: 50px;
  }
}

.slider-width {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/my_border/index.vue